import { inject, Injectable } from '@angular/core';
import { catchError, map, Observable, of, take } from 'rxjs';
import { ResponseUtil } from '../../../@common/http/response-util';
import { Logger } from '../../../@common/log/logger';
import { EntityType, V2SlugResource } from '../../../@generated';

@Injectable({
    providedIn: 'root'
})
export class SlugService {
    private logger = inject(Logger);
    private slugResource = inject(V2SlugResource);

    public getSlugType(slug: string): Observable<EntityType | undefined> {
        return this.slugResource.getEntityType(slug).pipe(
            take(1),
            map(({ entity_type }) => entity_type),
            catchError(e => {
                if (!ResponseUtil.is404Response(e)) {
                    this.logger.apiError('Get slug type failed', e);
                }

                return of(undefined);
            })
        );
    }
}
